module.exports = "/_next/static/images/62e034415f9ba7ab8fae7ae5da5b6edc-limit.png.webp";